export default __webpack_public_path__ + "static/media/galeri1.87d17db7.jpg";